export const GET_MEMBER_TAGS = "GET_MEMBER_TAGS";
export const GET_MEMBER_TAG_BY_ID = "GET_MEMBER_TAG_BY_ID";
export const UPDATE_MEMBER_TAG = "UPDATE_MEMBER_TAG";
export const DELETE_MEMBER_TAG = "DELETE_MEMBER_TAG";
export const CREATE_MEMBER_TAG = "CREATE_MEMBER_TAG";
